import { Text } from '@twilio-paste/core/text';

import { DataGridEmptyState } from '../../common/DataGrid';

export function AppsTableEmptyState() {
  return (
    <DataGridEmptyState colSpan={5}>
      <Text as="p" fontSize="fontSize40" marginBottom="space70">
        No applications found.
      </Text>
    </DataGridEmptyState>
  );
}
